import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { operatorsTabs } from './helpers/index';

const OperatorsTabs = () => <Tabs tabs={operatorsTabs} />;

export default OperatorsTabs;
